import type { HotelListQuery } from "@/lib/gql/__generated__/graphql";

import { HotelCard } from "./hotel-card";

type Props = {
	hotelList: HotelListQuery["hotelList"];
};

export const CompanyTopHotelList = ({ hotelList }: Props) => {
	return (
		<div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
			{hotelList.hotels.map((hotel) => (
				<HotelCard hotel={hotel} key={hotel.id} />
			))}
		</div>
	);
};

CompanyTopHotelList.displayName = "CompanyTopHotelList";
